/* eslint-disable @typescript-eslint/no-explicit-any */
// Imports for external libraries go here.
import React, { FC, useCallback, useState } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { MapViewProps } from './MapView.types';
import { StyledMapView } from './MapView.styles';
import { MapClustersComponent } from '../../molecules/MapClustersComponent';
import { MapComponent } from '@marriott/mi-ui-library';
import { GOOGLE_MAP_VAL_KEY } from '@marriott/shared/mi-helper-utils';

// Use named rather than default exports.
export const MapView: FC<MapViewProps> = props => {
  /**
   * State's Here...
   */
  const [openInfoWindow, setOpenInfoWindow] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState<any | null>(null);

  const mapOptions = {
    fullscreenControl: false,
    mapTypeControl: false,
    zoomControl: true,
    gestureHandling: 'greedy',
    mapId: 'ec5bb275520a7fc8',
  };

  const mapStyle = { height: '70vh', width: '100%' };

  const onMapLoad = useCallback((map: google.maps.Map) => {
    props.mapRef.current = map;
    setSelectedMarker(null);
  }, []);

  const closeInfoWindow = () => {
    setOpenInfoWindow(false);
  };

  return (
    <StyledMapView data-testid="luxury-MapView" data-component-name="m-luxury-MapView">
      {props?.isLoading ? (
        <div className="loader-container d-flex align-items-center justify-content-center" data-testid="facets-spinner">
          <div className="m-spinner-m"></div>
        </div>
      ) : (
        <MapComponent
          googleMapsApiKey={GOOGLE_MAP_VAL_KEY}
          mapId={mapOptions.mapId}
          mapContainerStyle={mapStyle}
          zoom={3}
          center={{
            lat:
              (selectedMarker?.node?.basicInformation?.latitude ||
                props?.markers?.[0]?.node?.basicInformation?.latitude) ??
              0,
            lng:
              (selectedMarker?.node?.basicInformation?.longitude ||
                props?.markers?.[0]?.node?.basicInformation?.longitude) ??
              0,
          }}
          onLoad={onMapLoad}
          options={mapOptions}
          // onCenterChanged={props?.handleCenterChange}
          mapHeight={'100%'}
          onClick={closeInfoWindow}
          onDragStart={closeInfoWindow}
        >
          {props?.markers ? (
            <MapClustersComponent
              markers={props?.markers}
              openInfoWindow={openInfoWindow}
              setOpenInfoWindow={setOpenInfoWindow}
              selectedMarker={selectedMarker}
              setSelectedMarker={setSelectedMarker}
              ctaLabel={props?.ctaLabel}
            />
          ) : (
            <div>No destinations found.</div>
          )}
        </MapComponent>
      )}
    </StyledMapView>
  );
};
